import { render, staticRenderFns } from "./BaseToolsSort.vue?vue&type=template&id=5ae65d21"
import script from "./BaseToolsSort.vue?vue&type=script&lang=js"
export * from "./BaseToolsSort.vue?vue&type=script&lang=js"
import style0 from "./BaseToolsSort.vue?vue&type=style&index=0&id=5ae65d21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports